import { NgModule } from '@angular/core';
import { AtomsModule } from '@atoms/atoms.module';
import { LayoutsModule } from '@layouts/layouts.module';
import { MoleculesModule } from '@molecules/molecules.module';

const Modules = [
  AtomsModule,
  LayoutsModule,
  MoleculesModule
];

@NgModule({
  imports: Modules,
  exports: Modules,
})
export class SharedModule { }
